<!--底图组件-->
<template>
  <div class="mapBox">
      <div id="gisContainer">
        <div id="popupInfo" style="position: absolute;width:auto;z-index: 100;"></div>
      </div>
    <div class="filter_wrap">
      <div style="display: none;">
        <el-button @click="activate('Point')">点</el-button>
        <el-button @click="activate('Polyline')">线</el-button>
        <el-button @click="activate('Polygon')">面</el-button>
        <el-button @click="clearAll()">清空</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import {mapGetters} from "vuex"
import * as Cesium from 'cesium';
import CesiumNavigation from 'cesium-navigation-es6';
import BuildingLayer from './layer/buildingLayer';
import WorkerLayer from './layer/workerLayer';
import VehicleLayer from './layer/vehicleLayer';
import RiskAreaLayer from './layer/riskAreaLayer';
import CameraLayer from './layer/cameraLayer';
import WorkPermitLayer from './layer/workPermitLayer';
import AlarmLayer from './layer/alarmLayer';
import DeviceLayer from './layer/deviceLayer';
import DangerLayer from './layer/dangerLayer';
import StoreLayer from './layer/storeLayer';
import CPVGasLayer from './layer/cpvGasLayer';
import EXGasLayer from './layer/exGasLayer';
import TrackLayer from './layer/trackLayer';
import CONSTANTS from "./constants";
import Overlay from './Overlay.js';
import MapUtil from './utils/mapUtil';
import * as MapService from "@/api/map";
import DrawTool from "@/views/map/utils/DrawTool";
import paths from "./../../../static/data/paths.json"
export default {
  name: 'Map',
  computed:{
    ...mapGetters({
    })
  },
  components: {
  },
  data(){
    return {
      isInitComplete:false,//是否加载完成
      layers:[
        {id:CONSTANTS.LAYER.WORKPERMIT,name:"作业票"},
        {id:CONSTANTS.LAYER.DANGER,name:"重大危险源"},
        {id:CONSTANTS.LAYER.RISKAREA,name:"风险区域"},
        {id:CONSTANTS.LAYER.DEVICE,name:"设备装置"},
        {id:CONSTANTS.LAYER.CAMERA,name:"监控探头"},
        {id:CONSTANTS.LAYER.WORKER,name:"人员"},
        {id:CONSTANTS.LAYER.VEHICLE,name:"车辆"},
        {id:CONSTANTS.LAYER.CPVGAS,name:"有毒气体"},
        {id:CONSTANTS.LAYER.EXGAS,name:"可燃气体"},
        {id:CONSTANTS.LAYER.STORE,name:"仓库物资"},
        {id:CONSTANTS.LAYER.ALARM,name:"报警"}
      ],
      overLayers:[CONSTANTS.LAYER.WORKER,CONSTANTS.LAYER.VEHICLE,CONSTANTS.LAYER.WORKPERMIT],//点击冒泡图层:
      detailBoxLayers:[
        CONSTANTS.LAYER.WORKPERMIT,
        CONSTANTS.LAYER.RISKAREA,
        CONSTANTS.LAYER.CAMERA,
        CONSTANTS.LAYER.DEVICE,
        CONSTANTS.LAYER.DANGER,
        CONSTANTS.LAYER.EXGAS,
        CONSTANTS.LAYER.CPVGAS],//点击显示右边详情框图层:作业票、风险区域、监控探头,设备,重大危险源,可燃气体,有毒气体
      initPosition:{longitude:118.0068086317,latitude:37.4909539775},//初始化位置,纬度wgs84
      userId:1,//当前用户id
    }
  },
  props:{
    showLayers:Array
  },
  mounted(){
    let self=this;
    this.userId=localStorage.getItem("userId");
    this.$nextTick(() => {
      //this.$refs.Statistics.getEchartsData()
    })
    self.initViewer();

    window.EventCenter.on('openTrack', (data) => {//打开轨迹
      console.log(data);
      self.trackLayer.addEntities(data.path);
    });
    window.EventCenter.on('closeTrack', (data) => {//关闭轨迹
      self.trackLayer.clearLayer();
    });

  },
  methods:{
    initViewer(){
      let self=this;
      //初始化viewer
      let viewer = new Cesium.Viewer('gisContainer',{
          shouldAnimate: true,//true ，否则为 false 。此选项优先于设置 Viewer＃clockViewModel 。
          animation: false, //是否创建动画小器件，左下角仪表
          baseLayerPicker: false, //是否显示图层选择器
          fullscreenButton: false, //是否显示全屏按钮
          geocoder: false, //是否显示geocoder小器件，右上角查询按钮
          homeButton: false, //是否显示Home按钮
          infoBox: false, //是否显示信息框
          selectionIndicator: false, //是否显示选取指示器组件
          timeline: false, //是否显示时间轴
          navigationHelpButton: false, //是否显示右上角的帮助按钮
          scene3DOnly: true, //如果设置为true，则所有几何图形以3D模式绘制以节约GPU资源
          clock: new Cesium.Clock(), //用于控制当前时间的时钟对象
          fullscreenElement: document.body, //全屏时渲染的HTML元素,
          useDefaultRenderLoop: true, //如果需要控制渲染循环，则设为true
          showRenderLoopErrors: false, //如果设为true，将在一个HTML面板中显示错误信息
          automaticallyTrackDataSourceClocks: true, //自动追踪最近添加的数据源的时钟设置
          sceneMode: Cesium.SceneMode.SCENE3D, //初始场景模式
          orderIndependentTranslucency: false,
          imageryProvider:new Cesium.WebMapTileServiceImageryProvider(CONSTANTS.TILE.tiandituImg),
          contextOptions: {
            webgl: {
              alpha: true,
            }
          },
      });
      viewer.scene.skyBox.show = false;
      viewer.scene.backgroundColor = new Cesium.Color(0.0, 0.0, 0.0, 0.0);

      //天地图
      viewer.imageryLayers.addImageryProvider(new Cesium.WebMapTileServiceImageryProvider(CONSTANTS.TILE.tiandituCia));

      let options = {};
      // 用于在使用重置导航重置地图视图时设置默认视图控制。接受的值是Cesium.Cartographic 和Cesium.Rectangle.
      options.defaultResetView = Cesium.Rectangle.fromDegrees(80, 22, 130, 50);
      // 罗盘,用于启用或禁用罗盘。true是启用罗盘，false是禁用罗盘。默认值为true。如果将选项设置为false，则罗盘将不会添加到地图中。
      options.enableCompass= true;
      // 缩放控件,用于启用或禁用缩放控件。true是启用，false是禁用。默认值为true。如果将选项设置为false，则缩放控件 将不会添加到地图中。
      options.enableZoomControls= true;
      // 距离图例,用于启用或禁用距离图例。true是启用，false是禁用。默认值为true。如果将选项设置为false，距离图例将不会添加到地图中。
      options.enableDistanceLegend= true;
      // 指南针外环,用于启用或禁用指南针外环。true是启用，false是禁用。默认值为true。如果将选项设置为false，则该环将可见但无效。
      options.enableCompassOuterRing= true;
      new CesiumNavigation(viewer, options);//主要方法
      window.viewer=viewer;
      document.getElementsByClassName('cesium-viewer-bottom')[0].style.display ='none';
      viewer.scene.globe.depthTestAgainstTerrain = false;//解决地形遮挡entity问题

      MapService.getModelList().then(res => {
        if (res.data.status_code === 100) {
          res.data.data.map((item)=>{
            item.scale=1;
            let coords=item.coor.split(",");
            item.longitude = Number(coords[0]);
            item.latitude = Number(coords[1]);
            let tileset=viewer.scene.primitives.add( new Cesium.Cesium3DTileset({
              url: item.url
            }));
            tileset.readyPromise.then(_tileset => {
              _tileset.name=item.type;
              _tileset.id=item.id;
              _tileset.type='tileset';
              let cartographic = Cesium.Cartographic.fromCartesian(
                  _tileset.boundingSphere.center
              );
              let longitude=item.longitude||Cesium.Math.toDegrees(cartographic.longitude);
              let latitude=item.latitude||Cesium.Math.toDegrees(cartographic.latitude);
              let height=cartographic.height;

              if(item.heading&&item.heading!=''){
                height=Number(item.heading);
              }
              //旋转角度设置
              let mx = Cesium.Matrix3.fromRotationX(Cesium.Math.toRadians(item.rotateX||0));
              let my = Cesium.Matrix3.fromRotationY(Cesium.Math.toRadians(item.rotateY||0));
              let mz = Cesium.Matrix3.fromRotationZ(Cesium.Math.toRadians(0));
              let rotationX = Cesium.Matrix4.fromRotationTranslation(mx);
              let rotationY = Cesium.Matrix4.fromRotationTranslation(my);
              let rotationZ = Cesium.Matrix4.fromRotationTranslation(mz);
              //平移 修改经纬度
              let position = Cesium.Cartesian3.fromDegrees(longitude,latitude,height);
              let transform = Cesium.Transforms.eastNorthUpToFixedFrame(position);
              //旋转、平移矩阵相乘
              Cesium.Matrix4.multiply(transform, rotationX, transform);
              Cesium.Matrix4.multiply(transform, rotationY, transform);
              Cesium.Matrix4.multiply(transform, rotationZ, transform);
              //缩放 修改缩放比例
              var scale = Cesium.Matrix4.fromUniformScale(item.scale||1);
              Cesium.Matrix4.multiply(transform, scale, transform);
              //赋值给tileset
              tileset._root.transform = transform;
              window.viewer.zoomTo(tileset);//飞行模型位置
            });
            //初始化相机

             this.initPosition={longitude:Number(coords[0]),latitude:Number(coords[1])};
            // viewer.camera.setView({
            //   destination:Cesium.Cartesian3.fromDegrees(Number(coords[0]), Number(coords[1]),Number(item.scale)),
            //   orientation:{
            //     heading : Cesium.Math.toRadians(Number(item.heading||0)),// 指向
            //     pitch : Cesium.Math.toRadians(Number(item.pitch||-90)),// 视角
            //     roll : Number(item.rotateZ||0)
            //   }
            // })
          })
        }
      })

      //冒泡
      let overlay = new Overlay({ viewer: viewer, element: document.getElementById('popupInfo') });
      MapUtil.setOverlay(overlay);

      //点击事件
      let handler =new Cesium.ScreenSpaceEventHandler(viewer.scene.canvas);
      window.paths=[];
      handler.setInputAction(function (movement) {
        let cartesian=viewer.camera.pickEllipsoid(movement.position,viewer.scene.globe.ellipsoid);
        let cartographic=Cesium.Cartographic.fromCartesian(cartesian);
        let lng=Cesium.Math.toDegrees(cartographic.longitude);//经度值
        let lat=Cesium.Math.toDegrees(cartographic.latitude);//纬度值
        let height=cartographic.height;//cartographic.height的值始终为零。

        let pick = viewer.scene.pick(movement.position);
        overlay.close();
        console.log([lng,lat,height],pick);
        window.paths.push([lng,lat]);
        if (pick&&pick.id&&pick.id.attributes) {
          window.EventCenter.emit('closeTrack', {});//关闭历史轨迹
          if(self.overLayers.indexOf(pick.id.attributes.layerName)>-1){
            MapUtil.openOverlay(pick.id);
          }

          if(self.detailBoxLayers.indexOf(pick.id.attributes.layerName)>-1){
            window.EventCenter.emit('openDetail',pick.id.attributes);
          }
        }
      }, Cesium.ScreenSpaceEventType.LEFT_CLICK);

      //建筑物图层
      this.buildingLayer =new BuildingLayer();
      MapService.getBuildingList().then(res => {
        if (res.data.status_code === 100) {
          this.buildingLayer.addEntities(res.data.data);
        }
      })
      //报警图层
      this.alarmLayer = new AlarmLayer();
      this.alarmLayer.addEntities(this.getRandomData("报警",5))
      //风险区域图层
      this.riskAreaLayer = new RiskAreaLayer();
      MapService.getRiskAreaList().then(res => {
        if (res.data.status_code === 100) {
          this.riskAreaLayer.addEntities(res.data.data);
        }
      })
      //摄像头图层
      this.cameraLayer = new CameraLayer();
      //this.cameraLayer.addEntities(this.getRandomData("摄像头",5));
      MapService.getCameraList().then(res => {
        if (res.data.status_code === 100) {
          this.cameraLayer.addEntities(res.data.data);
        }
      });
      //作业票图层
      this.workPermitLayer = new WorkPermitLayer();
      //this.workPermitLayer.addEntities(this.getRandomData("workerOrder",5));
      MapService.getWorkPermitList().then(res => {
        if(res.data.status_code === 100) {
          this.workPermitLayer.addEntities(res.data.data);
        }
      })
      //员工图层
      this.workerLayer = new WorkerLayer();
      //this.workerLayer.addEntities(this.getRandomData("作业者",1));
      MapService.getWorkerList().then(res => {
        if (res.data.status_code === 100) {
          this.workerLayer.addEntities(res.data.data);
        }
      })
      //车辆图层
      this.vehicleLayer = new VehicleLayer();
      //this.vehicleLayer.addEntities(this.getRandomData("货车",5));
      MapService.getVehicleList().then(res => {
        if (res.data.status_code === 100) {
          this.vehicleLayer.addEntities(res.data.data);
        }
      })

      //设备图层
      this.deviceLayer = new DeviceLayer();
      //this.deviceLayer.addEntities(this.getRandomData("设备",5));
      MapService.getDeviceList().then(res => {
        if (res.data.status_code === 100) {
          this.deviceLayer.addEntities(res.data.data);
        }
      })
      //重大危险源图层
      this.dangerLayer=new DangerLayer();
      //this.dangerLayer.addEntities(this.getRandomData("危险源",5));
      MapService.getDangerList().then(res => {
        if (res.data.status_code === 100) {
          this.dangerLayer.addEntities(res.data.data);
        }
      })
      //仓库物资图层
      this.storeLayer=new StoreLayer();
      //this.storeLayer.addEntities(this.getRandomData("仓库",5));
      MapService.getStoreList().then(res => {
        if (res.data.status_code === 100) {
          this.storeLayer.addEntities(res.data.data);
        }
      })
      //有毒气体图层
      this.cpvGasLayer=new CPVGasLayer();
      //this.cpvGasLayer.addEntities(this.getRandomData("有毒气体",5));
      //可燃气体图层
      this.exGasLayer=new EXGasLayer();
      //this.exGasLayer.addEntities(this.getRandomData("可燃气体",5));
      MapService.getHarmList().then(res => {
        if (res.data.status_code === 100) {
          this.cpvGasLayer.addEntities(res.data.data);
          this.exGasLayer.addEntities(res.data.data);
        }
      })
      //轨迹图层
      this.trackLayer=new TrackLayer();
      this.isInitComplete=true;

      //图层显示处理
      for(let item of this.layers){
        let layer=MapUtil.getLayerByName(item.id);
        if(layer){
          layer.setVisible(false);
        }
      }


      //每3s获取人员与车辆位置信息
      this.interval=setInterval(() => {
        if(this.workerLayer.getVisible()){
          MapService.getWorkerList().then(res => {
            if (res.data.status_code === 100) {
              let data=[...res.data.data];
              if(this.userId==18){
                data.forEach((item,index)=>{
                  if(index==parseInt(data.length*Math.random())){
                    let pathIndex=0;
                    let entity=self.workerLayer.getEntityById(item.id);
                    let path;
                    if(entity){
                      path=entity.attributes.path;
                      pathIndex=entity.attributes.pathIndex;
                      if(pathIndex>path.length-2){
                        pathIndex=0;
                      }else{
                        pathIndex=pathIndex+1;
                      }
                    }else{
                      let d=parseInt(12*Math.random()); //输出0～20之间的随机整数
                      path=paths[d];
                    }
                    item.pathIndex=pathIndex;
                    item.path=path;
                    item.longitude= path[pathIndex][0];
                    item.latitude=path[pathIndex][1];
                  }
                })
              }
              MapUtil.closeOverlay();
              this.workerLayer.updateEntities(data);
            }
          })
        }
        if(this.vehicleLayer.getVisible()){
          MapService.getVehicleList().then(res => {
            if (res.data.status_code === 100) {
              let data=[...res.data.data];
              if(this.userId==18){
                data.forEach((item,index)=>{
                  if(index==parseInt(data.length*Math.random())) {
                    let pathIndex = 0;
                    let entity = self.vehicleLayer.getEntityById(item.id);
                    let path;
                    if (entity) {
                      path = entity.attributes.path;
                      pathIndex = entity.attributes.pathIndex;
                      if (pathIndex > path.length - 2) {
                        pathIndex = 0;
                      } else {
                        pathIndex = pathIndex + 1;
                      }
                    } else {
                      let d = parseInt(12 * Math.random()); //输出0～20之间的随机整数
                      path = paths[d];
                    }
                    item.pathIndex = pathIndex;
                    item.path = path;
                    item.longitude = path[pathIndex][0];
                    item.latitude = path[pathIndex][1];
                  }
                })
              }
              MapUtil.closeOverlay();
              this.vehicleLayer.updateEntities(data);
            }
          })
        }
      }, 3000)

      //绘制工具
      this.drawTool=new DrawTool(viewer);

    },

    activate(drawType){
      this.drawTool.activate(drawType,(data)=>{
        console.log(data);
      });
    },

    clearAll(){
      this.drawTool.clearAll();
    },

    getRandomData(type,length){

      let points=[];
      for(let i=0;i<length;i++){
        points.push({id:i,name:type+"00"+i,factor:0,cerType:Math.floor(Math.random() * 4+ 1),type:type,longitude:this.initPosition.longitude+Math.random()*0.001*(Math.random()>0.5?1:-1),latitude:this.initPosition.latitude+Math.random()*0.0005*(Math.random()>0.5?1:-1)});
      }
      return points;
    },
    changeLayer(layerName){
      let layer=MapUtil.getLayerByName(layerName);
      if(layer){
        layer.setVisible(!layer.getVisible());
      }
    },
  },
  beforeDestroy() {
    this.alarmLayer&& this.alarmLayer.destroy();
    this.eleFenceLayer&& this.eleFenceLayer.destroy();
    this.cameraLayer&& this.cameraLayer.destroy();
    this.workPermitLayer&& this.workPermitLayer.destroy();
    this.workerLayer&& this.workerLayer.destroy();
    this.vehicleLayer&& this.vehicleLayer.destroy();
    this.deviceLayer&& this.deviceLayer.destroy();
    this.dangerLayer&& this.dangerLayer.destroy();
    this.storeLayer&& this.storeLayer.destroy();
    this.cpvGasLayer&& this.cpvGasLayer.destroy();
    this.exGasLayer&& this.exGasLayer.destroy();
    this.isInitComplete=false;
    window.EventCenter.removeListener('openTrack', () => { });//解除监听
    window.EventCenter.removeListener('closeTrack', () => { });//解除监听
    this.interval&&window.clearInterval(this.interval);
  }
}
</script>
<style scoped>
@import "map.css";
</style>
